import React, { useEffect, useState } from "react";
import { Button, Col, Nav, Row, Spinner, Tab } from "react-bootstrap";
import Card from "../../components/Card";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import { BaseState, StateKeys } from "../../redux/states/main.state";
import {
  AppPageScrollDownLoadMore,
  AppState,
  CheckContentProviderIdExist,
  getContentProviderId,
  getLanguageByDefault,
  InfoLogger,
  SearchLocal,
} from "../../services/app.service";
import {
  ClassResponse,
  ContentResponse,
  CourseResponse,
  SubscriptionResponse,
  TestResponse,
  TestResultResponse,
} from "../../services/api.response.service";
import Main from "../../redux/actions/main.action";
import ApiEndpoint from "../../services/api.endpoint.service";
import { RouteComponentProps, useParams } from "react-router";
import NoData from "./NoData";
import { RouteEndpoints } from "../../services/route.service";
import Loader from "../../components/Loader";

import { Link } from "react-router-dom";
import SubscribeAccessButton from "../../components/classCourse/SubscribeAccessButton";
import Api from "../../services/api.service";
import { toInteger } from "lodash";
import { Mixpanel } from "../../services/mixpanel";
import ClassDetailsView from "../../components/classCourse/ClassDetailsView";

function ClassCourses({ location }: RouteComponentProps) {
  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;
  const { ecampus_id } = useSelector(
    (state: IRootState) => state.setting.user!,
  );

  let { id } = useParams<{ id: string }>();
  let { link } = useParams<{ link: string }>();
  // const id = location.pathname.replace(RouteEndpoints.CLASS_COURSES(""), "");
  const tab = location.hash.replace("#", "");
  const dispatch = useDispatch();
  const state = useSelector((state: IRootState) => state.main);
  const getLanguage = getLanguageByDefault();

  // const dataPersist = state[StateKeys.DATA_PERSIST];
  const {
    data: sData,
    pageState: sPageState,
    currentPage: sCurrentPage,
    hasMore: sHasMore,
  }: BaseState<Array<SubscriptionResponse>> = state[
    StateKeys.USER_SUBSCRIPTION
  ];
  const subscription =
    sData.length > 0
      ? // ? subscriptions.data.find((e) => String(e.subscriber_class.id) === getClassId())
        sData.find((e) => String(e.subscriber_class.link_name) === link)
      : undefined;

  const [search, setSearch] = useState("");

  const [courseDetails, setCourseDetails] = useState<CourseResponse>();
  const activeClass: BaseState<ClassResponse> = state[StateKeys.ACTIVE_CLASS];

  const getClassId = () => {
    let theId = String((activeClass.data as ClassResponse).id);
    // let theId = (theClass?.id)
    // let theId = ""
    if (
      theId &&
      theId !== "" &&
      theId !== undefined &&
      theId !== "undefined" &&
      theId !== null
    ) {
      id = theId;
      // return theId
    }

    // if(id && id !== ""){
    if (
      id &&
      id !== "" &&
      id !== undefined &&
      id !== "undefined" &&
      id !== null
    ) {
      return id;
    }
    // if (link && link !== "") {
    //       return link
    // }
    // return (String((activeClass.data as ClassResponse).id));
    return "";
  };

  const [theClass, setTheClass] = useState<ClassResponse | null>(null);
  const [contents, setContents] = useState<ContentResponse[] | []>([]);
  const [tests, setTests] = useState<TestResponse[] | []>([]);

  const getClass = async (classId: string | number) => {
    const classObj = await Api.getActiveClassByMeans(String(classId));
    if (classObj) {
      // console.log("the class",classObj.data.data);
      setTheClass(classObj.data.data);
      return classObj.data;
    }
    return null;
  };

  const getContents = async (classId: string | number) => {
    const contentsObj = await Api.getClassCourseStructure(toInteger(classId));
    if (contentsObj) {
      // console.log("contents",contentsObj.data.data);
      setContents(contentsObj.data.data);
      return contentsObj.data;
    }
    return null;
  };

  const getTests = async (classId: string | number) => {
    const resObj = await Api.getClassTest(toInteger(classId));
    if (resObj) {
      // console.log("tests",resObj.data.data);
      setTests(resObj.data.data);
      return resObj.data;
    }
    return null;
  };

  useEffect(() => {
    let classId = getClassId();
    classId = id ? id : link;
    // console.log("classId",classId);
    if (classId) {
      getClass(classId);
    }
  }, [link, id]);

  const [mp, setMp] = useState<boolean>(false);

  useEffect(() => {
    if (theClass) {
      getContents(theClass?.id);
      getTests(theClass?.id);

      if (!mp) {
        // Mixpanel.identify(user.id);
        Mixpanel.track("Class Details View", {
          with: currentUser?.id ? "Auth" : "Guest",
          user_id: currentUser?.id,
          class_id: theClass?.id,
          class_name: theClass?.name,
          ...(theClass?.content_provider_id
            ? { content_provider_id: theClass?.content_provider_id }
            : {}),
        });
        setMp(true);
        // console.log("Mixpanel", theClass?.id, theClass?.name);
      }
    }
    // console.log(getContentProviderId(), theClass?.content_provider.id,theClass);
  }, [theClass]);

  useEffect(() => {
    // if (
    //   details.hasMore &&
    //   details.pageState !== AppState.LOADING_MORE &&
    //   details.pageState === AppState.LOADED
    // ) {
    //   dispatch(
    //     Main.getPaginatedPageData({
    //       stateKey: StateKeys.CLASS_COURSES,
    //       apiEndpoint: ApiEndpoint.CLASS_COURSES((getClassId())),
    //       previousPage: details.currentPage!,
    //       storeKey: StateKeys.CLASS_COURSES.concat("-", getClassId()),
    //     })
    //   );
    // }
    //
    // setShowCourses(details.data);
    // if (details.obj !== null) {
    //   setHasSubscribed(details.obj!.is_subscribed);
    // }
    // get more courses for pagination
  }, [theClass]);

  useEffect(() => {
    // if (
    //   tests.hasMore &&
    //   tests.pageState !== AppState.LOADING_MORE &&
    //   tests.pageState === AppState.LOADED
    // ) {
    //   dispatch(
    //     Main.getPaginatedPageData({
    //       stateKey: StateKeys.CLASS_TESTS,
    //       apiEndpoint: ApiEndpoint.CLASS_TESTS((getClassId())),
    //       previousPage: tests.currentPage!,
    //       storeKey: StateKeys.CLASS_TESTS.concat("-", getClassId()),
    //     })
    //   );
    // }
    //
    // setShowTests(tests?.data);
    // get more tests to show
  }, [tests]);

  useEffect(() => {
    // getCourseSearchData(contents);
    // getTestSearchData(tests);
  }, [search]);

  // const getCourseSearchData = (data: Array<CourseResponse>) =>
  // setShowCourses(
  //   data.filter((item) =>
  //     SearchLocal(search.toLowerCase(), [
  //       item.title.toLowerCase(),
  //       item.description.toLowerCase(),
  //     ])
  //   )
  // );

  // const getTestSearchData = (data: Array<TestResponse>) =>
  // setShowTests(
  //   data.filter((item) =>
  //     SearchLocal(search.toLowerCase(), [
  //       item.name.toLowerCase(),
  //       item.description.toLowerCase(),
  //       item.instructions.toLowerCase(),
  //       item.duration.toString(),
  //     ])
  //   )
  // );

  function fullshow(tclass: ClassResponse) {
    if (CheckContentProviderIdExist()) {
      return Number(getContentProviderId()) == tclass?.content_provider.id;
    }
    return true;
  }

  console.log("theClass", theClass);
  return (
    <div
      className="content-page scroller-hide"
      // onScroll={(e) => AppPageScrollDownLoadMore(e, loadMore)}
    >
      <Row>
        {theClass && (
          <>
            {theClass.id ? (
              !fullshow(theClass) ? (
                <div className="text-center pt-5 mt-5">
                  {/*  Because the peron on CP view and class is not part of CP*/}
                  <h5 className="pb-3">{getLanguage.sorryYouCannot}</h5>
                  <Link
                    to={RouteEndpoints.CLASS_COURSES(String(theClass.id))}
                    className="text-decoration-none btn btn-primary"
                  >
                    {getLanguage.clickHereToAccessContent}
                  </Link>
                  {/* <a
                                  href={`web.ecampus.camp/classes/${getClassId()}/courses`}
                                  target="_blank"
                                  className="text-decoration-none btn btn-primary"
                                  rel="noreferrer"
                                >
                                  {getLanguage.clickHereToAccessContent}
                                </a> */}
                </div>
              ) : (
                <div className="d-flex flex-column gap-2">
                  <ClassDetailsView
                    classDetails={theClass}
                    // contents={contents}
                    tests={tests}
                    tab={tab}
                  />
                </div>
              )
            ) : (
              <NoData
                title="classNotFound"
                link={RouteEndpoints.HOME}
                btnText="backHome"
              />
            )}
          </>
        )}

        {/*<Col md={12}>*/}
        {/*  {details.hasMore &&*/}
        {/*    !(*/}
        {/*      details.pageState === AppState.LOADING ||*/}
        {/*      details.pageState === AppState.LOADING_MORE*/}
        {/*    ) && (*/}
        {/*      <div*/}
        {/*        className={`w-100 text-center shadow-xss rounded-xxl border-0 px-3`}*/}
        {/*      >*/}
        {/*        <button*/}
        {/*          className="text-decoration-none btn btn-primary"*/}
        {/*          onClick={() => loadMore()}*/}
        {/*        >*/}
        {/*          {getLanguage.loadMore}*/}
        {/*        </button>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*</Col>*/}

        {/*<Col md={12}>*/}
        {/*  {(details.pageState === AppState.LOADING ||*/}
        {/*    details.pageState === AppState.LOADING_MORE) && (*/}
        {/*    <Loader noCard imageLoader />*/}
        {/*  )}*/}
        {/*</Col>*/}
        {/*  */}
        {/*{details.pageState === AppState.ERROR_404 && (*/}
        {/*  <NoData*/}
        {/*    title="classNotFound"*/}
        {/*    link={RouteEndpoints.HOME}*/}
        {/*    btnText="backHome"*/}
        {/*  />*/}
        {/*)}*/}
      </Row>
      {/*    )*/}
      {/*}*/}
    </div>
  );
}

export default ClassCourses;
